import { render, staticRenderFns } from "./InsuredFormDriver.vue?vue&type=template&id=cba66e94&scoped=true&"
import script from "./InsuredFormDriver.vue?vue&type=script&lang=ts&"
export * from "./InsuredFormDriver.vue?vue&type=script&lang=ts&"
import style0 from "./InsuredFormDriver.vue?vue&type=style&index=0&id=cba66e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba66e94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
